module.exports = __webpack_public_path__ + "static/media/Rubik-Light.46a16fa3.ttf";